import React from "react";
import CommaUpIcon from '../../img/comma-up.png';
import CommaDownIcon from '../../img/comma-down.png';

export const CommaUp = () => {
    return(
        <>
        <img src={CommaUpIcon} />
        </>
    )
}

export const CommaDown = () => {
    return(
        <>
        <img src={CommaDownIcon} />
        </>
    )
}
